import { render, staticRenderFns } from "./GoogleCloud.vue?vue&type=template&id=45e7e5de&"
import script from "./GoogleCloud.vue?vue&type=script&lang=js&"
export * from "./GoogleCloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45e7e5de')) {
      api.createRecord('45e7e5de', component.options)
    } else {
      api.reload('45e7e5de', component.options)
    }
    module.hot.accept("./GoogleCloud.vue?vue&type=template&id=45e7e5de&", function () {
      api.rerender('45e7e5de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/GoogleCloud.vue"
export default component.exports